import React from 'react';
import ListSystem from '../../../Components/ADD_Fact_Components/listSystem';

const Fact_System = () => {
    return ( 
        <ListSystem size={"small"} disableAction={true}/>
     );
}
 
export default Fact_System;